import React from 'react';

import AppState from "./AppState";

import { MapState } from "./MapState";

import { DataTableState } from "../components/Common/DataTable/DataTableState";

import { DataTableChildState } from "../components/Common/DataTable/DataTableChildState";

import { DataTableCommonState } from "../components/Common/DataTable/DataTableCommonState";

import { WebSocketProvider } from '../pages/LiveLog/WebSocketLiveLog';
import { DataTableProvider } from '../components/Common/DataTableEngine/shared/Context';

// RNL here used **********DataTableState********** and **********DataTableChildState**********
const ParentDataTableState = DataTableCommonState(DataTableState);

const SubDataTableState = DataTableCommonState(DataTableChildState);

const MainState = ( props ) => {

    return  (
        <AppState>
            <WebSocketProvider>
            <ParentDataTableState >
                <SubDataTableState>
                    <MapState>
                        <DataTableProvider>
                        {props.children}
                        </DataTableProvider>
                    </MapState>
                </SubDataTableState>
            </ParentDataTableState>
            </WebSocketProvider>
        </AppState>
    )
}


export default MainState;

